import { IOffer } from '../repositories/search-offers/v2/types/offer';
import { getFirstNextUserOffer } from './getFirstNextUserOffer';
import { getOfferServices } from './getOfferServices';

export const offersDecorator = (offers: IOffer[], isAdditionalTop3Disabled: boolean) => {
  offers.forEach((offer, index) => {
    if (offer.isAuction && offer.auction && !offer.auction.isOwn) {
      const userOffer = getFirstNextUserOffer(offers, index + 1);

      if (userOffer) {
        offer.auction.userOfferId = userOffer.id;
        offer.auction.userOfferServices = getOfferServices(userOffer);
      }
    }

    if (isAdditionalTop3Disabled) {
      delete offer.top3Place;
    }
  });
};
